import Vue from 'vue'
import Router from 'vue-router'
import systemrouter from './systemrouter'
import Basic from './Basic'
import {
  BlankLayout
} from '@/layouts'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '*',
      name: '404',
      component: () => import(/* webpackChunkName: "fail" */ '@/views/Exception/404')
    },
    {
      path: '/',
      component: BlankLayout,
      redirect: '/',
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import(/* webpackChunkName: "about" */ '../views/Home/index.vue')
        }
      ]
    },
    systemrouter.managesystem,
    Basic
  ]
})
